/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface NamedEntity
 */
export interface NamedEntity {
    /**
     * 
     * @type {number}
     * @memberof NamedEntity
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof NamedEntity
     */
    end?: number;
    /**
     * 
     * @type {number}
     * @memberof NamedEntity
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof NamedEntity
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof NamedEntity
     */
    text?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof NamedEntity
     */
    tokens?: Array<number>;
}

/**
 * Check if a given object implements the NamedEntity interface.
 */
export function instanceOfNamedEntity(value: object): boolean {
    return true;
}

export function NamedEntityFromJSON(json: any): NamedEntity {
    return NamedEntityFromJSONTyped(json, false);
}

export function NamedEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): NamedEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
        'score': json['score'] == null ? undefined : json['score'],
        'label': json['label'] == null ? undefined : json['label'],
        'text': json['text'] == null ? undefined : json['text'],
        'tokens': json['tokens'] == null ? undefined : json['tokens'],
    };
}

export function NamedEntityToJSON(value?: NamedEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'start': value['start'],
        'end': value['end'],
        'score': value['score'],
        'label': value['label'],
        'text': value['text'],
        'tokens': value['tokens'],
    };
}

